// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-fxE","questions":"styles_questions__dHHfF","footer":"styles_footer__1PQ2A"};